import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubstituteParent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.2276 4.32673C3.92415 4.63018 3.92415 5.12088 4.2276 5.42111C4.35944 5.55154 4.52661 5.62592 4.69815 5.64344C4.75096 5.64884 4.80419 5.64885 4.85692 5.64344C5.02718 5.626 5.19234 5.55215 5.32198 5.42111L7.09753 3.64556L6.95671 5.64344L6.95671 14.6895C6.95671 15.1188 7.44618 15.4642 7.87554 15.4642C8.3049 15.4642 8.92784 15.1188 8.92784 14.6895L8.94663 5.64344L8.65033 3.64556L10.4259 5.42111C10.5545 5.54977 10.7169 5.62388 10.8841 5.64344C11.1112 5.67001 11.3473 5.5959 11.5203 5.42111C11.8205 5.11765 11.8237 4.62696 11.5203 4.32673L8.42435 1.22759C8.12089 0.924136 7.6302 0.924136 7.32997 1.22759L4.23083 4.32673L4.2276 4.32673Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.09753 3.64556L5.32198 5.42111C5.19234 5.55215 5.02718 5.626 4.85692 5.64344L6.95671 5.64344L7.09753 3.64556Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.65033 3.64556L8.94663 5.64344L10.8841 5.64344C10.7169 5.62388 10.5545 5.54977 10.4259 5.42111L8.65033 3.64556Z",
			fill: "#FF6B00"
		})
	]
});
export default SvgSubstituteParent;
